import { BotSchema, NlpModel, StepNlpSettings, StepSchema } from '@feedyou-ai/feedbot-schema'

import { convertQuestionLikeStepToNlpModel } from './convertQuestionLikeStepToNlpModel'
import { getNlpConfigForStep } from '../stepNlp'

type Params = {
  step: StepSchema
  stepNlpSettings: StepNlpSettings
  stepTypeDefaults?: BotSchema['stepTypeDefaults']
}

export const convertStepToNlpModel = ({
  step,
  stepNlpSettings,
  stepTypeDefaults
}: Params): NlpModel | null => {
  const config = getNlpConfigForStep(step, stepNlpSettings)

  switch (step.type) {
    case 'question':
    case 'prompt':
      return convertQuestionLikeStepToNlpModel(
        step,
        config,
        stepTypeDefaults.question?.grammars as any
      )
    default:
      throw new Error('Converting non-question steps to model is not currently supported')
  }
}
